import { SvgIcon } from "@mui/material"

import { ReactComponent } from "./campaign.svg"

export const CampaignIcon = (props) => {
    return (
        <SvgIcon component={ReactComponent} {...props} inheritViewBox />
    )
}

